import RecipeFilterController from '@/recipe-filter/Controllers/RecipeFilterController';

document.addEventListener('DOMContentLoaded', () => {
  RecipeFilterController();
});
